import { render, staticRenderFns } from "./ContentContainer.vue?vue&type=template&id=19f5aa24&scoped=true"
import script from "./ContentContainer.vue?vue&type=script&lang=js"
export * from "./ContentContainer.vue?vue&type=script&lang=js"
import style0 from "./ContentContainer.vue?vue&type=style&index=0&id=19f5aa24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f5aa24",
  null
  
)

export default component.exports